import React from "react";
import {
  AdminOnly,
  ResTecnicoAccess,
  BasicUserAccess,
} from "../components/RoleBasedAccess";
import { useUserRole } from "../hooks/useUserRole";
import "./EsempioRuoli.css";

const EsempioRuoli = () => {
  const { isAdmin, isResTecnico, isBasicUser } = useUserRole();

  return (
    <div className="esempio-ruoli-container">
      <h1>Esempio di Accesso Basato sui Ruoli</h1>

      {/* Mostra il ruolo attuale dell'utente */}
      <div className="user-role-info">
        <h2>Il tuo ruolo attuale:</h2>
        {isAdmin && <p className="role admin">Amministratore</p>}
        {isResTecnico && !isAdmin && (
          <p className="role res-tecnico">Responsabile Tecnico</p>
        )}
        {isBasicUser && <p className="role basic-user">Utente Base</p>}
        {!isAdmin && !isResTecnico && !isBasicUser && (
          <p className="role not-logged">Non autenticato</p>
        )}
      </div>

      <div className="role-based-sections">
        {/* Contenuto visibile a tutti gli utenti autenticati */}
        <BasicUserAccess>
          <section className="basic-section">
            <h3>Funzionalità per Utenti Base</h3>
            <ul>
              <li>Visualizzazione del profilo personale</li>
              <li>Accesso alle presenze personali</li>
              <li>Visualizzazione delle comunicazioni aziendali</li>
            </ul>
          </section>
        </BasicUserAccess>

        {/* Contenuto visibile solo ai Responsabili Tecnici e Admin */}
        <ResTecnicoAccess>
          <section className="res-tecnico-section">
            <h3>Funzionalità per Responsabili Tecnici</h3>
            <ul>
              <li>Gestione delle presenze del team</li>
              <li>Approvazione delle richieste di permesso</li>
              <li>Visualizzazione dei report di produttività</li>
              <li>Assegnazione di task ai membri del team</li>
            </ul>
          </section>
        </ResTecnicoAccess>

        {/* Contenuto visibile solo agli Admin */}
        <AdminOnly>
          <section className="administrator-section">
            <h3>Funzionalità per Amministratori</h3>
            <ul>
              <li>Gestione completa degli utenti</li>
              <li>Assegnazione dei ruoli</li>
              <li>Configurazione delle impostazioni aziendali</li>
              <li>Accesso ai dati finanziari</li>
              <li>Gestione delle autorizzazioni di sistema</li>
            </ul>
          </section>
        </AdminOnly>
      </div>
    </div>
  );
};

export default EsempioRuoli;
